var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2871_34896)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FAFBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7077 16.3612C24.324 16.296 23.801 16.2911 22.8575 16.2911C21.2603 16.2911 20.125 16.2924 19.2642 16.4076C18.421 16.5204 17.9365 16.7321 17.5843 17.0843C17.2316 17.437 17.0202 17.92 16.9075 18.7584C16.7923 19.6148 16.791 20.7437 16.791 22.3327V25.6661C16.791 27.2551 16.7923 28.384 16.9075 29.2404C17.0202 30.0788 17.2316 30.5618 17.5843 30.9145C17.9369 31.2671 18.42 31.4785 19.2584 31.5913C20.1148 31.7064 21.2437 31.7077 22.8327 31.7077H26.166C27.755 31.7077 28.8839 31.7064 29.7403 31.5913C30.5787 31.4785 31.0618 31.2671 31.4144 30.9145C31.7671 30.5618 31.9785 30.0788 32.0912 29.2404C32.2064 28.384 32.2077 27.2551 32.2077 25.6661V25.3018C32.2077 24.0218 32.1987 23.415 32.0628 22.9577H29.4546C28.5106 22.9577 27.7391 22.9578 27.1301 22.8759C26.4935 22.7903 25.9415 22.6051 25.5009 22.1645C25.0604 21.7239 24.8751 21.1719 24.7895 20.5353C24.7076 19.9263 24.7077 19.1548 24.7077 18.2108V16.3612ZM25.9577 17.0073V18.1661C25.9577 19.1658 25.959 19.8528 26.0284 20.3688C26.0953 20.8668 26.2152 21.111 26.3848 21.2806C26.5544 21.4502 26.7986 21.5701 27.2966 21.637C27.8126 21.7064 28.4996 21.7077 29.4993 21.7077H31.1822C30.9352 21.4681 30.6187 21.181 30.2077 20.8111L26.9087 17.842C26.5042 17.478 26.2032 17.2092 25.9577 17.0073ZM22.9789 15.041C24.1327 15.0407 24.8782 15.0405 25.5643 15.3038C26.2504 15.5671 26.802 16.0638 27.6554 16.8323C27.6849 16.8588 27.7147 16.8857 27.7449 16.9129L31.0439 19.882C31.079 19.9136 31.1137 19.9448 31.148 19.9756C32.1344 20.8628 32.7722 21.4365 33.1153 22.2069C33.4584 22.9772 33.4581 23.8351 33.4577 25.1618C33.4577 25.2079 33.4577 25.2546 33.4577 25.3018V25.7131C33.4577 27.2445 33.4577 28.4576 33.3301 29.4069C33.1987 30.3839 32.9219 31.1747 32.2983 31.7984C31.6747 32.422 30.8839 32.6988 29.9069 32.8301C28.9575 32.9578 27.7445 32.9577 26.213 32.9577H22.7857C21.2542 32.9577 20.0412 32.9578 19.0918 32.8301C18.1148 32.6988 17.324 32.422 16.7004 31.7984C16.0767 31.1747 15.8 30.3839 15.6686 29.4069C15.541 28.4576 15.541 27.2445 15.541 25.7131V22.2857C15.541 20.7542 15.541 19.5412 15.6686 18.5919C15.8 17.6149 16.0767 16.8241 16.7004 16.2004C17.3245 15.5763 18.1179 15.2998 19.0984 15.1686C20.0517 15.041 21.2708 15.041 22.8106 15.0411L22.8575 15.0411C22.8985 15.0411 22.9389 15.041 22.9789 15.041Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0101 24.7934C21.7697 24.568 21.3956 24.568 21.1552 24.7934L19.4886 26.3559C19.2367 26.592 19.224 26.9875 19.4601 27.2394C19.6961 27.4912 20.0917 27.5039 20.3435 27.2679L20.9577 26.692L20.9577 29.4161C20.9577 29.7612 21.2375 30.0411 21.5827 30.0411C21.9279 30.0411 22.2077 29.7612 22.2077 29.4161L22.2077 26.692L22.8219 27.2679C23.0737 27.5039 23.4692 27.4912 23.7053 27.2394C23.9414 26.9875 23.9286 26.592 23.6768 26.3559L22.0101 24.7934Z",
    fill: "#3B82F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2871_34896",
    x: -4.5,
    y: -5,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2871_34896"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2871_34896",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload_file.7ccc43736490647660e177dca55ae26a.svg";